module.exports = __webpack_public_path__ + "static/media/san-jose.ef07e6d7.jpg";